import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './globalAddresses.actions.js';
import getters from './globalAddresses.getters.js';
import mutations from './globalAddresses.mutations.js';
import state from './globalAddresses.state.js';

BaseStore.registerModule('globalAddresses', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('globalAddresses');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
